'use strict';
import isNumber from 'lodash/isNumber';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';


export function ProgressBarView(props) {
  if (props.isIndefinite) {
    return (
      <div className={classNames("ProgressBar", props.className)}>
        <div className="ProgressBar__barContainer" />
        <div className="ProgressBar__count">
          <i className="icon ion-load-c spin" />
        </div>
      </div>
    );
  } else {
    return (
      <div className={classNames("ProgressBar", props.className)}>
        <div className="ProgressBar__barContainer">
          <div
            className="ProgressBar__bar"
            style={{width: `${isNumber(props.progress) ? props.progress : 0}%`}}
          />
        </div>
        <div className="ProgressBar__count">
          <span>
            {`${formatProgress(props.progress)}%`}
          </span>
        </div>
      </div>
    );
  }
}

ProgressBarView.propTypes = {
  className: T.string,
  isIndefinite: T.bool,
  progress: T.number,
};

ProgressBarView.defaultProps = {
  className: '',
};

function formatProgress(progress) {
  return Math.floor(progress); // we might show a 1/10 digit
}



// WEBPACK FOOTER //
// ./src/js/components/ProgressBar/ProgressBarView.js